import { CHATBOT_URL } from '@/app/constants';
import { envs } from '@/app/utils/envs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import chatIcon from '@/public/public/images/chat.png';
import { useIsUserInFloatingButtonGroup } from '@/app/hooks/useIsUserInFloatingButtonGroup';
import { mixpanelTrack } from '@/app/hooks/useAnalytics/mixpanel-track';
import { MixpanelEvent } from '@/app/hooks/useAnalytics/types';

const openChat = (startOpened: boolean = true, launcherImageUrl: string, language: string): void => {
  const script = document.createElement('script');
  script.src = CHATBOT_URL;
  script.async = true;
  script.onload = () => {
    setTimeout(() => {
      if (window.amioWebchat) {
        window.amioWebchat.init({
          channelId: envs.amioChannelId,
          theme: 'donio',
          lang: `${language}-donio`,
          startOpened,
          storageType: 'local',
          launcherImageUrl,
          zIndex: 1000,
        });

        // Mixpanel events
        if (window.CookieConsent && window.CookieConsent.consent.preferences) {
          mixpanelTrack(
            MixpanelEvent.ChatbotEvent,
            {
              event_type: "chatbot_opened"
            }
          );

          window.amioWebchat.onUserEvent(
            (userEventName, userEventParams = null) => {
              const properties = {
                event_type: userEventName
              };
              if (userEventParams !== null) {
                Object.assign(properties, userEventParams);
              }

              mixpanelTrack(
                MixpanelEvent.ChatbotEvent,
                properties
              );
            }
          );
        }
      }
    }, 1);
  };
  script.onerror = () => console.error('Chat loading failed');
  document.body.appendChild(script);
};

const imageUrl = `${envs.publicBaseUrl}/${chatIcon.src}`;

export const ChatBot = () => {
  const { i18n } = useTranslation();
  const [shouldBePlaceholderDisplayed, setShouldBePlaceholderDisplayed] = useState(true);
  const isUserInFloatingButtonGroup = useIsUserInFloatingButtonGroup();

  const handleOpenChat = () => {
    openChat(true, imageUrl, i18n?.language);
    setShouldBePlaceholderDisplayed(false);
  };

  if (isUserInFloatingButtonGroup) {
    return null;
  }

  if (!shouldBePlaceholderDisplayed) {
    return null;
  }

  return (
    <div className="fixed z-[100] bottom-[26px] right-[32px]" id="chatOpener">
      <button className="h-[55px] p-[5px] w-[55px] rounded-full bg-primary-mid" onClick={handleOpenChat}>
        <img className="scale-[0.6]" alt="chatbot icon" src={imageUrl} />
      </button>
    </div>
  );
};
